import React, { useEffect } from 'react';
import Spin from 'components/Spin';
import * as authService from 'services/auth.service';
import toast from 'utils/toast';
import { login } from 'store/modules/user/actions';
import { useDispatch } from 'react-redux';

const LoginWithToken = ({ match, history }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const { token } = match.params;
    loginWithToken(token);
  }, []);

  const loginWithToken = async (token) => {
    try {
      const resp = await authService.loginWithToken(token);
      onLoginSuccess(resp);
    } catch (e) {
      toast.error(e.message);
    } finally {
      history.replace('/login');
    }
  };

  const onLoginSuccess = (resp) => {
    dispatch(login(resp));
    history.replace('/');
  };

  return <Spin spinning tip="Loading..." />;
};

export default LoginWithToken;
